import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

import { COCComponent } from "./coc.component";
import { ListMailboxComponent } from "./mailbox/list-mailbox/list-mailbox.component";
import { DetailMailboxComponent } from "./mailbox/detail-mailbox/detail-mailbox.component";
import { MailboxComponent } from "./mailbox/mailbox.component";
import { QueryComponent } from "./query/query.component";
import { RequestComponent } from "./request/request.component";
import { ListQueryComponent } from "./query/list-query/list-query.component";
import { ClearFiltersGuard } from "../core/guards/clear-filters.guard";

const routesCOC: Routes = [
  {
    path: "",
    component: COCComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "buzon",
        component: MailboxComponent,
        children: [
          {
            path: "lista",
            component: ListMailboxComponent,
            canActivate: [ClearFiltersGuard],
          },
          {
            path: "detalle/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
            },
          },
        ],
      },
      {
        path: "solicitud",
        component: RequestComponent,
      },
      {
        path: "consulta",
        component: QueryComponent,
        children: [
          {
            path: "lista",
            component: ListQueryComponent,
            canActivate: [ClearFiltersGuard],
          },
          {
            path: "detalle/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
              type: "NotHistory",
              url: "consulta",
            },
          },
          {
            path: "detalle/historico/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
              type: "history",
              url: "consulta",
            },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesCOC)],
  exports: [RouterModule],
})
export class COCRoutingModule {}
